import type { QueryOptionsOverride } from '../queryOptions.helpers';
import type { BundleOfferDto } from './bundleOffers.schema';
import { queryOptions } from '@tanstack/react-query';
import { QueriesKeys } from '../queriesKeys';
import { bundlesApi } from './bundles.api';

export const userBundleOffersQueryOptions = {
  list: (options?: QueryOptionsOverride<Array<BundleOfferDto>>) => queryOptions({
    queryKey: [QueriesKeys.bundleOffers],
    queryFn: () => bundlesApi.getUserBundleOffers(),
    ...options,
  }),

};
